<template>
  <div class="feature-section feature-two section-padding white-bg">
    <div class="container">
      <div class="row">
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-12 wow fadeInLeft animated"
          data-wow-delay="200ms"
        >
          <div class="single-feature-item">
            <div class="feature-item-inner">
              <div class="feature-icon">
                <i class="flaticon-money-2"></i>
              </div>
              <div class="feature-title">
                <h4 class="text-white">Corporate Tax Services</h4>
              </div>
            </div>
            <p>
              Comprehensive support in registration, return filing, and advisory services 
              for UAE corporate tax compliance
            </p>
            <RouterLink
              :to="{ name: 'Services' }"
              class="service-details-link"
            >
              <i class="las la-arrow-right"></i>
            </RouterLink>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-12 wow fadeInLeft animated"
          data-wow-delay="400ms"
        >
          <div class="single-feature-item">
            <div class="feature-item-inner">
              <div class="feature-icon">
                <i class="flaticon-bar-chart"></i>
              </div>
              <div class="feature-title">
                <h4 class="text-white">VAT Services & Compliance</h4>
              </div>
            </div>
            <p>
              Expert assistance with VAT registration, periodic filing, refund claims, 
              and compliance monitoring
            </p>
            <router-link
              :to="{ name: 'Services' }"
              class="service-details-link"
            >
              <i class="las la-arrow-right"></i>
            </router-link>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-12 wow fadeInLeft animated"
          data-wow-delay="600ms"
        >
          <div class="single-feature-item">
            <div class="feature-item-inner">
              <div class="feature-icon">
                <i class="flaticon-hr"></i>
              </div>
              <div class="feature-title">
                <h4 class="text-white">Accounting & Bookkeeping</h4>
              </div>
            </div>
            <p>
              Accurate, timely, and reliable accounting services handling everything 
              from financial statements to reconciliations
            </p>
            <router-link
              :to="{ name: 'Services' }"
              class="service-details-link"
            >
              <i class="las la-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Feature2",
};
</script>
